/* istanbul ignore file */
import React, { useCallback, useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import AddIcon from '@mui/icons-material/Add';
import { UPDATE_PROCESS_VARIABLES_LIST } from 'domain/gpo/cockpit/instance/Show/variables/processVariablesService';
import { useAuthorization } from 'framework/authorization';
import AddProcessVariableModalForm from 'domain/gpo/cockpit/instance/Show/variables/shared/AddProcessVariableModalForm';

const AddProcessVariableButton = () => {
  const { isGranted } = useAuthorization();

  const isButtonHidden = !isGranted(UPDATE_PROCESS_VARIABLES_LIST);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openCloseIssueForm = useCallback(() => {
    setIsFormOpen(true);
  }, [setIsFormOpen]);

  const closeModal = useCallback(() => {
    setIsFormOpen(false);
  }, [setIsFormOpen]);

  return isButtonHidden ? null : (
    <>
      <Button onClick={openCloseIssueForm}>
        <AddIcon />
        Add variable
      </Button>
      {isFormOpen && <AddProcessVariableModalForm closeModal={closeModal} />}
    </>
  );
};

export default AddProcessVariableButton;
